import { Localization } from '../../../localization/localization';

export enum RegistrationErrorCode {
    WRONG_OTP = 9,
    NOT_REGISTERED = 17,
    TOO_MANY_REQUESTS = 429,
    WRONG_EMAIL = 16,
    EMAIL_EXISTS = 18,
    BAD_REQUEST = 400
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessage(errorCode: number, errorData: any): string {
    let msg: string;
    switch (errorCode) {
        case RegistrationErrorCode.WRONG_EMAIL:
            msg = 'errors.email_wrong';
            break;
        case RegistrationErrorCode.EMAIL_EXISTS:
            msg = 'errors.already_reg';
            break;
        case RegistrationErrorCode.WRONG_OTP:
            msg = 'otp_request_code.not_full';
            break;
        case RegistrationErrorCode.BAD_REQUEST:
            msg = errorData.error ?? 'errors.common_error';
            break;
        case RegistrationErrorCode.TOO_MANY_REQUESTS:
            msg = 'errors.too_many_requests';
            break;
        case RegistrationErrorCode.NOT_REGISTERED:
        default:
            msg = 'errors.common_error';
    }

    return Localization._n(msg);
}
